import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-confirm-account',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.css']
})
export class ConfirmAccountComponent implements OnInit {
  code: string = '';
  responseObject:ResponseObject = new ResponseObject();
  showRequest=false;
  defaultMsgBool = false;
  constructor(
    private alertService: AlertService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private globalSrv: GlobalServices,) { 

      this.alertService.clear();
      this.code = this.route.snapshot.params.Code;
      
      this.userService.ConfirmAccount(this.code)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
         this.responseObject = data;
         this.defaultMsgBool = true;
         if(this.responseObject.Success) 
         {
           this.showRequest=true;
             // this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.CONFIRM_ACCOUNT'), false);
            
         }
          else{
            this.showRequest=false;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+this.responseObject.ErrorMessages[0]), false);
          }
          
        });
  }

  ngOnInit() {
  }
  goToHome() {
    this.globalSrv.goToHome();
  }
}
